import React, { Component, forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Row, Col, Drawer, Space, Button, Tabs, Form, message, Spin } from 'antd';
// import axios from "axios"
// import { CheckCircleOutlined, CheckOutlined, CloseCircleOutlined, LockOutlined, ShoppingOutlined, UploadOutlined } from '@ant-design/icons';
// import { AiOutlineMinusCircle } from "react-icons/ai";
import axios from "axios";

import InformacionGeneral from "./DrawerSorteo/InformacionGeneral";
import Descripciones from "./DrawerSorteo/Descripciones";
import ImagesForm from "./DrawerSorteo/ImagesForm";
import Premios from "./DrawerSorteo/Premios";
import { useForm } from "antd/lib/form/Form";
// import Ejemplo from "./DrawerSorteo/Ejemplo";

const { TabPane } = Tabs;


const DrawerSorteoForwadRefWrapper = forwardRef(function DrawerSorteo(props, ref) {

    const { sorteo_id, onClose } = props


    const [loading, setLoading] = useState(false)

    const [sorteo, setSorteo] = useState()
    const [sorteoId, setSorteoId] = useState(sorteo_id)

    const [tab, setTab] = useState('informacion-general')

    const [formInformacionGeneral] = Form.useForm();
    const [formDescripciones] = Form.useForm();
    const [formImages] = Form.useForm();

    const getForm = () => {
        switch (tab) {
            case 'informacion-general':
                return formInformacionGeneral
            case 'descripciones-banner':
                return formDescripciones
            case 'images':
                return formImages
            case 'premios':
                return null
        }
    }

    /**
    * @method getSorteo
    * @description Obtiene la informacion de un sorteo
    */
    const getSorteo = () => {
        setLoading(true)
        axios.get('/sorteo/' + sorteo_id)
            .then(({ data }) => {
                setSorteo(data)
            })
            .catch(error => {
                console.log("error", error);
                message.error(error?.response?.data?.message ?? "Error al obtener la información")
            })
            .finally(() => setLoading(false))
    }


    const goTo = () => {
        if (tab == "informacion-general") setTab('descripciones-banner')
        else if (tab == "descripciones-banner") setTab('images')
        else if (tab == "images") setTab('premios')
        else onClose()

    }

    const onFinish = (values, goTo) => {



        try {
            if (values?.fechas?.length > 0) {
                values.fecha_inicio = values.fechas[0]
                values.fecha_finalizacion = values.fechas[1]
            }

            console.log("DRAWER RIFA SAVE", values)
            if (values?.estado_id?._id) values.estado_id = values?.estado_id?._id
            if (values?.pais_id?._id) values.pais_id = values?.pais_id?._id
            else if (values?.pais_id?.value) values.pais_id = values?.pais_id?.value
            // if (values?.pais_id?._id) values.pais_id = values?.pais_id?._id


            const formData = new FormData()
            formData.appendMultiple({
                sorteo_id: sorteoId,
                ...values,
                banner: undefined, //JSON.stringify(values.banner),
                imagenes_celular: undefined,//JSON.stringify((values.imagenes_celular ?? []).filter(e => !e.originFileObj)),
                imagenes_escritorio: undefined,//JSON.stringify((values.imagenes_escritorio ?? []).filter(e => !e.originFileObj)),
            })


            console.log("values.banner", values.banner)
            if (values.banner) {
                if (values.banner.file instanceof File) values.banner = values.banner.file

                if (values.banner instanceof File)
                    formData.append("banner", values.banner, values.banner.name)
                else
                    formData.append("banner", JSON.stringify(null))
            }


            if (Array.isArray(values.imagenes_escritorio)) {
                let imagenes = []
                values.imagenes_escritorio = values.imagenes_escritorio.map(imagen => {

                    if (imagen.originFileObj instanceof File) imagen = imagen.originFileObj
                    if (imagen.file instanceof File) imagen = imagen.file

                    if (imagen instanceof File)
                        formData.append("imagenes_escritorio", imagen, imagen.name)
                    else
                        imagenes.push(imagen)

                })
                formData.append("imagenes_escritorio", JSON.stringify(imagenes))
            }
            if (Array.isArray(values.imagenes_celular)) {
                let imagenes = []
                values.imagenes_celular = values.imagenes_celular.map(imagen => {

                    if (imagen.originFileObj instanceof File) imagen = imagen.originFileObj
                    if (imagen.file instanceof File) imagen = imagen.file

                    if (imagen instanceof File)
                        formData.append("imagenes_celular", imagen, imagen.name)
                    else
                        imagenes.push(imagen)

                })
                formData.append("imagenes_celular", JSON.stringify(imagenes))
            }


            if (sorteoId)
                update(formData)
            else {
                add(formData)
            }
        } catch (e) {
            console.log("Error al realizar submit", e)
        }
    }

    /**
    * @method addSorteo
    * @description Añade un nuevo registro de rifas
    */
    const add = (values) => {
        setLoading(true)
        axios.post('/sorteo', values, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(({ data }) => {
                message.success("Creado con exito")
                setSorteo(data)
                setSorteoId(data._id)
            })
            .catch(error => {
                console.log("error", error);
                message.error(error?.response?.data?.message ?? "Error al registrar")
            }).finally(() => setLoading(false))
    }

    /**
    * @method updateSorteo
    * @description Añade un nuevo registro de rifas
    */
    const update = (values) => {
        setLoading(true)
        axios.put('/sorteo/' + sorteoId, values, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(({ data }) => {
                message.success("Actualizado con exito")
                setSorteo(data)
                setSorteoId(data._id)
                // if (sor)
                goTo()
            })
            .catch(error => {
                console.log("error", error);
                message.error(error?.response?.data?.message ?? "Error al registrar")
            })
            .finally(() => setLoading(false))
    }


    useEffect(() => {
        if (sorteo_id) {
            getSorteo()
        }
    }, [])

    useImperativeHandle(ref, () => ({
        submit: () => {
            const cForm = getForm()

            console.log("cForm", cForm)
            if (cForm && cForm != null)
                cForm.submit()
            else
                onClose();
        },
    }));

    return <Spin spinning={loading}>
        <Tabs
            // defaultActiveKey=""
            activeKey={tab}
            onChange={e => {
                setTab(e)
            }}

            destroyInactiveTabPane={true}
            forceRender={true}
        >
            <TabPane
                tab="Información General"
                key="informacion-general"
            >
                <InformacionGeneral
                    form={formInformacionGeneral}
                    onFinish={onFinish}
                    sorteo={sorteo}
                />
            </TabPane>
            <TabPane
                disabled={!sorteoId}
                tab="Descripciones y Banner"
                key="descripciones-banner"
            >
                <Descripciones
                    form={formDescripciones}
                    onFinish={onFinish}
                    sorteo={sorteo}
                />
            </TabPane>
            <TabPane
                disabled={!sorteoId}
                tab="Imágenes"
                key="images"
            >
                <ImagesForm
                    form={formImages}
                    onFinish={onFinish}
                    sorteo={sorteo}
                />
            </TabPane>
            <TabPane
                disabled={!sorteoId}
                tab="Premios"
                key="premios"
            >
                <Premios
                    // form={formImages}
                    // onFinish={onFinish}
                    sorteo={sorteo}
                />
            </TabPane>
        </Tabs>
    </Spin>
});




export default function DrawerSorteoWrapper(props) {

    const { open = false, onClose = () => { }, sorteo_id } = props

    const sorteoDrawerRef = useRef()

    const saveValues = () => {
        sorteoDrawerRef.current.submit()
    }

    return <Drawer
        title={`${props.sorteo_id ? "Editar" : "Nuevo"} Sorteo`}
        placement={"bottom"}
        onClose={onClose}
        open={open}
        key={"bottom"}
        height={800}
        destroyOnClose={true}
        extra={
            <Space>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={saveValues} type="primary">
                    Aceptar
                </Button>
            </Space>
        }
    >
        <DrawerSorteoForwadRefWrapper ref={sorteoDrawerRef} {...props} />
    </Drawer>

}